import { Select, Spin } from "antd";
import React from "react";

const { Option } = Select;

export const SearchSelect = ({
  onChange,
  onFocus,
  onBlur,
  onSearch,
  options,
  placeholder,
  isDisabled,
  error,
  id,
  value,
  loading,
  onPopupScroll,
  notFoundContent,
}) => {
  const handleChange = (selectedValue) => {
    onChange(selectedValue);
  };

  return (
    <>
      <Select
        showSearch
        style={{ width: 200 }}
        placeholder={placeholder}
        className="form-select p-0 w-100"
        optionFilterProp="children"
        onChange={handleChange}
        onFocus={onFocus}
        id={id}
        value={value}
        onBlur={onBlur}
        onSearch={onSearch}
        onPopupScroll={onPopupScroll}
        loading={loading}
        suffixIcon={null}
        listHeight={200}
        filterOption={(input, option) =>
          option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        disabled={isDisabled}
        dropdownRender={(menu) => (
          <>
            {menu}
            {loading && (
              <div style={{ textAlign: "center", padding: "8px" }}>
                <Spin size="small" />
              </div>
            )}
          </>
        )}
      >
        {options.map((option, index) => (
          <Option key={index} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
      {error && <div className="error">{error}</div>}
    </>
  );
};
